var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangePhone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1470_36357)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1470_36357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.6959 2.29748C8.28984 1.31662 7.21934 0.794548 6.19629 1.07404L1.55566 2.33967C0.638086 2.59279 0 3.42599 0 4.37521C0 17.4217 10.5785 28.0002 23.625 28.0002C24.5742 28.0002 25.4074 27.3621 25.6605 26.4445L26.9262 21.8039C27.2057 20.7809 26.6836 19.7104 25.7027 19.3043L20.6402 17.1949C19.7807 16.8363 18.784 17.0842 18.1986 17.8067L16.0682 20.4065C12.3557 18.6504 9.3498 15.6445 7.59375 11.932L10.1936 9.80685C10.916 9.21623 11.1639 8.22482 10.8053 7.36525L8.6959 2.30275V2.29748Z",
    fill: "#FB512D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1470_36357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1470_36357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(0 1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangePhone);
export default __webpack_public_path__ + "static/media/orangePhone.291f05b35129875987bfe6c908d76c9a.svg";
export { ForwardRef as ReactComponent };